import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from 'Actions';
import ImportWizardHeader from './ImportWizardHeader';
import { GreenUploadCloud } from 'Utils/SvgIcons';
import { history } from 'Components/utils/router/history';
import { PRETTY_NAMES, LIST_PATHS } from 'HelperFunctions/import_wizard';

// Done step: the commit job's counts and messages (no revert: dropped in the Release 38 review).
class ImportWizardDone extends Component {
  state = { dataType: '' };

  componentDidMount() {
    const { dataType } = this.props.match.params;
    this.setState({ dataType });
    this.props.openSuccessSnackBar('Import completed!');
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.business &&
      !prevProps.business.permissions.importWizardEnabled
    ) {
      history.push('/unauthorized');
    }
  }

  response = () => this.props.location?.state?.response || {};

  render() {
    const { dataType } = this.state;
    const response = this.response();
    const counts = response.counts || {};
    const errors = response.errors || [];
    return (
      <div className='contentWrapper'>
        <ImportWizardHeader
          importStatus='done'
          displayButtons={false}
          headerTitle='Done'
        />
        <div className='ImportWizardUploadContainer'>
          <div className='importWizardUpload'>
            <span className='importWizardDone'>
              <GreenUploadCloud />
              {response.message && (
                <pre
                  className='importWizardDoneMessage'
                  id='import_wizard_done_message'
                >
                  {response.message}
                </pre>
              )}
              {response.counts && (
                <div
                  className='adjustTableMatches'
                  id='import_wizard_done_counts'
                >
                  <span className='matches'>
                    <b>{counts.created || 0}</b> created
                  </span>
                  <span className='updates'>
                    <b>{counts.updated || 0}</b> updated
                  </span>
                  {counts.unchanged > 0 && (
                    <span className='rows'>
                      <b>{counts.unchanged}</b> unchanged
                    </span>
                  )}
                  <span className='skipped'>
                    <b>{counts.skipped || 0}</b> skipped
                  </span>
                  <span className={counts.failed ? 'problems' : 'matches'}>
                    <b>{counts.failed || 0}</b> failed
                  </span>
                </div>
              )}
              {errors.length > 0 && (
                <ul className='importWizardDoneErrors'>
                  {errors.map(([line, detail], index) => (
                    <li key={index}>
                      Row {line} - {detail.error}
                    </li>
                  ))}
                </ul>
              )}
              <a
                className='btn full'
                id='import_wizard_see_records'
                onClick={() =>
                  history.push(LIST_PATHS[dataType] || '/inventory/items')
                }
              >
                See {PRETTY_NAMES[dataType] || 'records'}
              </a>
              <a
                className='btnLink'
                onClick={() => history.push('/importWizard')}
              >
                Import history
              </a>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ business: state.business.business });

export default withRouter(connect(mapStateToProps, actions)(ImportWizardDone));
